/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_TriggerInputs */

const cs_integrations_trigger = /** @type {(inputs: Integrations_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spouštěč`)
};

const en_integrations_trigger = /** @type {(inputs: Integrations_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger`)
};

/**
* | output |
* | --- |
* | "Trigger" |
*
* @param {Integrations_TriggerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_trigger = /** @type {((inputs?: Integrations_TriggerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_TriggerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_trigger(inputs)
	return cs_integrations_trigger(inputs)
});